import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Badge } from '../Badge';
import { useWizardsSidebarContext } from './WizardsSidebarContext';
import { onlyTextChildren } from '../../utils';
import { Icon } from '../Icon';
import Check from '@mollie/ui-assets/icons/utilitarian/Check';
import CheckFilled from '@mollie/ui-assets/icons/utilitarian/CheckFilled';
export const WizardsStep = forwardRef(function WizardsStep(props, ref) {
    const { children, elementType: Element = props.href ? 'a' : 'div', label, status = 'pending', className, ...rest } = props;
    const sidebarVariant = useWizardsSidebarContext();
    return (React.createElement("li", { className: clsx('mollie-ui-wizard-step', {
            [`mollie-ui-wizard-step--${status}`]: status,
        }) },
        React.createElement(Element, { ...rest, className: clsx('mollie-ui-wizard-step-element', className), ref: ref, "aria-current": status === 'current' ? 'true' : undefined, "aria-label": sidebarVariant === 'horizontal'
                ? label !== null && label !== void 0 ? label : onlyTextChildren(children)
                : undefined },
            React.createElement("div", { className: "mollie-ui-wizard-step-indicator" },
                React.createElement("span", { className: "mollie-ui-wizard-step-indicator-start" }),
                React.createElement(Badge, { className: "mollie-ui-wizard-badge" }, status === 'completed' && (React.createElement(Icon, { src: sidebarVariant != null ? CheckFilled : Check, className: "mollie-ui-wizard-icon" }))),
                React.createElement("span", { className: "mollie-ui-wizard-step-indicator-end" })),
            sidebarVariant !== 'horizontal' && (React.createElement("div", null, label ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "mollie-ui-wizard-step-label" }, label),
                children && (React.createElement("div", { className: "mollie-ui-wizard-step-content" }, children)))) : (children))))));
});
WizardsStep.displayName = 'Wizards.Step';
//# sourceMappingURL=WizardsStep.js.map